export enum PageLayout {
    Default = 'default',
    Sidebar = 'sidebar', // with sidebar
    Center = 'center', // centered content, no frame
    Cta = 'cta', // centered content, blank
    Blank = 'blank', // no frame
    Public = 'public', // for landing page
    PublicSecondary = 'PublicSecondary', // for blog page
    ClientDefault = 'clientDefault', // client  default
    VendorDefault = 'vendorDefault', // client  default
    Jobs = 'jobs',
    EasyMode = 'easyMode',
    Admin = 'admin', // platform administration area (super admins only)
}
